export default function (subFlows, branchOnProductCodeFn) {
    // this function will get passed step,junction and flow parameters but we here we are not creating any new steps
    // or junctions just to wiring up entry and exits so they are not needed.
    return function () {
        if (subFlows.paFlows) {
            subFlows.paFlows.contactDetails.exits.paContactDetailsComplete.onNext.goTo(subFlows.needToSaveCheck.entry);
            subFlows.paFlows.coverables.exits.paCoverablesComplete.onNext.goTo(subFlows.quote.entry);
            subFlows.paFlows.moreInfo.exits.paMoreInfoComplete.onNext.goTo(subFlows.bind.entry);
        }

        if (subFlows.hoFlows) {
            subFlows.hoFlows.contactDetails.exits.hoContactDetailsComplete.onNext.goTo(subFlows.needToSaveCheck.entry);
            subFlows.hoFlows.coverables.exits.hoCoverablesComplete.onNext.goTo(subFlows.quote.entry);
            subFlows.hoFlows.moreInfo.exits.hoMoreInfoComplete.onNext.goTo(subFlows.bind.entry);
        }

        if (subFlows.cpFlows) {
            subFlows.cpFlows.coverables.exits.cpCoverablesComplete.onNext.goTo(subFlows.quote.entry);
            subFlows.cpFlows.moreInfo.exits.cpMoreInfoComplete.onNext.goTo(subFlows.bind.entry);
        }

        if (subFlows.bopFlows) {
            subFlows.bopFlows.contactDetails.exits.bopContactDetailsComplete.onNext.goTo(subFlows.needToSaveCheck.entry);
            subFlows.bopFlows.coverables.exits.bopCoverablesComplete.onNext.goTo(subFlows.quote.entry);
            subFlows.bopFlows.moreInfo.exits.bopMoreInfoComplete.onNext.goTo(subFlows.bind.entry);
        }

        if (subFlows.wcFlows) {
            subFlows.wcFlows.contactDetails.exits.wcContactDetailsComplete.onNext.goTo(subFlows.needToSaveCheck.entry);
            subFlows.wcFlows.coverables.exits.wcCoverablesComplete.onNext.goTo(subFlows.quote.entry);
            subFlows.wcFlows.moreInfo.exits.wcMoreInfoComplete.onNext.goTo(subFlows.bind.entry);
        }

        subFlows.needToSaveCheck.exits.needToSaveCheckSuccess.onNext.branch(branchOnProductCodeFn(subFlows.paFlows, subFlows.hoFlows, subFlows.cpFlows, subFlows.bopFlows, subFlows.wcFlows, 'coverables'));

        subFlows.quote.exits.offeringSelected.onNext.branch(branchOnProductCodeFn(subFlows.paFlows, subFlows.hoFlows, subFlows.cpFlows, subFlows.bopFlows, subFlows.wcFlows, 'moreInfo'));
    };
}


//////////////////
// WEBPACK FOOTER
// ./common/js/src/integration/quoteandbind/config/_wireLOBSection.js
// module id = 398
// module chunks = 0